// extracted by mini-css-extract-plugin
export var full = "InputBox-module--full--sq6VS";
export var half = "InputBox-module--half--39-oI";
export var income = "InputBox-module--income--uPUmD";
export var annual_income = "InputBox-module--annual_income--2Zubv";
export var incomeDisplay = "InputBox-module--income-display--2wx0w";
export var sub = "InputBox-module--sub--17epb";
export var placeholder = "InputBox-module--placeholder--1_Rrb";
export var unit = "InputBox-module--unit--24bKL";
export var withUnit = "InputBox-module--with-unit--2Fsb8";